// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #eff0eb;
}
.main1 {
  position: absolute;
  width: 45%;

  left: 30%;
  top: 35%;
  border: 1px solid #000000;
  display: flex;
  flex-direction: column;
  padding: 7px;
}

.frame-bar {
  background-color: #000000;
  /* margin-top: 7px;
  margin-right: 7px;
  margin-left: 7px; */
  width: 100%;
  display: flex;
  align-items: center;
}

.square {
  width: 10px;
  height: 10px;
  background-color: #eff0eb;
  margin-left: 10px;
}

.frame-bar h3 {
  font-family: "N27";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */
  margin-left: 8px;
  text-align: left;
  letter-spacing: -0.02em;
  text-transform: uppercase;
  color: #eff0eb;
}

.congo {
  margin-top: 20px;
  margin-bottom: 20px;
}

.congo h1 {
  font-family: "PP NeueBit";
  font-style: normal;
  font-weight: 700;
  font-size: 54.4649px;
  line-height: 39px;
  /* identical to box height */
  text-align: center;
  letter-spacing: -0.02em;

  color: #151515;
}

@media only screen and (max-width: 800px) {
  .congo h1 {
    font-size: 40px;
  }
}

.info {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 20px;
}

@media only screen and (max-width: 920px) {
  .info {
    margin-bottom: 0;
  }
}

.info h2 {
  font-family: "N27";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  /* or 125% */

  margin-left: 10px;
  margin-right: 10px;
  /* padding: 15px; */
  text-align: center;
  letter-spacing: -0.02em;
  text-transform: uppercase;
}

.socials1 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-family: "PP NeueBit";
  font-style: normal;
  font-weight: 700;
  font-size: 24.46px;
  line-height: 17px;
  margin: 20px 0px;
}

.socials1 a {
  text-decoration: none;
  color: #151515;
}

@media only screen and (max-width: 600px) {
  .main1 {
    left: 7%;

    width: 83.3%;
    height: auto;
    
  }

  .congo {
    margin: 0;
  }

  .congo h1 {
    /* font-size: 18px; */
    margin: 0;
  }

  .info {
    position: relative;
    top: -4%;
    margin: 0;
  }

  .info h2 {
    font-size: 10px;
  }

  .socials1 {
    position: relative;
    /* top: -10%; */
    /* left: 15%; */
    align-items: center;

    width: 100%;
    font-weight: 700;
    font-size: 12px;
    line-height: 9px;
    justify-content: space-around;
    margin-top: unset;
    margin: auto;
    margin-bottom: 5%;
  }

  .socials1 div {
    /* margin-right: 50px;
    margin-left: 50px; */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Fom/components/SuccessPage/Success.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;;EAEV,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB;;qBAEmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;;EAEvB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;;EAEZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,QAAQ;;IAER,YAAY;IACZ,YAAY;;EAEd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;;IAEnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE;wBACoB;EACtB;AACF","sourcesContent":["body {\n  background-color: #eff0eb;\n}\n.main1 {\n  position: absolute;\n  width: 45%;\n\n  left: 30%;\n  top: 35%;\n  border: 1px solid #000000;\n  display: flex;\n  flex-direction: column;\n  padding: 7px;\n}\n\n.frame-bar {\n  background-color: #000000;\n  /* margin-top: 7px;\n  margin-right: 7px;\n  margin-left: 7px; */\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.square {\n  width: 10px;\n  height: 10px;\n  background-color: #eff0eb;\n  margin-left: 10px;\n}\n\n.frame-bar h3 {\n  font-family: \"N27\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n  /* identical to box height */\n  margin-left: 8px;\n  text-align: left;\n  letter-spacing: -0.02em;\n  text-transform: uppercase;\n  color: #eff0eb;\n}\n\n.congo {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.congo h1 {\n  font-family: \"PP NeueBit\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 54.4649px;\n  line-height: 39px;\n  /* identical to box height */\n  text-align: center;\n  letter-spacing: -0.02em;\n\n  color: #151515;\n}\n\n@media only screen and (max-width: 800px) {\n  .congo h1 {\n    font-size: 40px;\n  }\n}\n\n.info {\n  margin-left: 10px;\n  margin-right: 10px;\n  margin-bottom: 20px;\n}\n\n@media only screen and (max-width: 920px) {\n  .info {\n    margin-bottom: 0;\n  }\n}\n\n.info h2 {\n  font-family: \"N27\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  /* or 125% */\n\n  margin-left: 10px;\n  margin-right: 10px;\n  /* padding: 15px; */\n  text-align: center;\n  letter-spacing: -0.02em;\n  text-transform: uppercase;\n}\n\n.socials1 {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  font-family: \"PP NeueBit\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24.46px;\n  line-height: 17px;\n  margin: 20px 0px;\n}\n\n.socials1 a {\n  text-decoration: none;\n  color: #151515;\n}\n\n@media only screen and (max-width: 600px) {\n  .main1 {\n    left: 7%;\n\n    width: 83.3%;\n    height: auto;\n    \n  }\n\n  .congo {\n    margin: 0;\n  }\n\n  .congo h1 {\n    /* font-size: 18px; */\n    margin: 0;\n  }\n\n  .info {\n    position: relative;\n    top: -4%;\n    margin: 0;\n  }\n\n  .info h2 {\n    font-size: 10px;\n  }\n\n  .socials1 {\n    position: relative;\n    /* top: -10%; */\n    /* left: 15%; */\n    align-items: center;\n\n    width: 100%;\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 9px;\n    justify-content: space-around;\n    margin-top: unset;\n    margin: auto;\n    margin-bottom: 5%;\n  }\n\n  .socials1 div {\n    /* margin-right: 50px;\n    margin-left: 50px; */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
